import { initialState } from '.';
import jwtDecode from 'jwt-decode';

export default {
	SET_TOKEN(state, payload) {
		const tokenData = jwtDecode(payload.token);

		state.token = {
			token: payload.token,
			refreshToken: payload.refreshToken,
			...tokenData,
			role: Array.isArray(tokenData.role) ? tokenData.role : [tokenData.role],
			license: Array.isArray(tokenData.license)
				? tokenData.license
				: [tokenData.license]
		};
	},

	SET_TOKENS_FROM_REFRESH(state, payload) {
		state.token.token = payload.token;
		state.token.refreshToken = payload.refreshToken;
	},

	SET_USER(state, payload) {
		state.user = payload;
	},

	SET_ACTIVE_CUSTOMER(state, payload) {
		state.activeCustomer = payload;
	},

	SET_ACTIVE_BUILDING(state, payload) {
		state.activeBuilding = payload;
	},

	SET_LICENSE(state, payload) {
		state.activeCustomer.license = payload;
	},

	SET_ACTIVE_COMPANY(state, payload) {
		state.activeCompany = payload;
	},

	SET_DROPDOWN_USERS(state, users) {
		state.dropdownUsers = users;
	},

	SET_USERS(state, users) {
		state.users = users;
	},

	SET_LOGGEDIN_USER(state, user) {
		state.getUser = user;
	},

	SET_PAGESIZE(state, pageSize) {
		state.searchParams.pageSize = pageSize;
	},

	SET_CURRENTPAGE(state, currentPage) {
		state.searchParams.currentPage = currentPage;
	},

	SET_TOTALPAGES(state, totalPages) {
		state.totalPages = totalPages;
	},

	SET_TOTALCOUNT(state, totalCount) {
		state.totalCount = totalCount;
	},

	SET_ALLOWCCUSTOMERAPIKEY(state, allowCustomerApiKey) {
		state.allowCustomerApiKey = allowCustomerApiKey;
	},

	LOGOUT(state) {
		Object.assign(state, initialState());
	}
};
